import TapFullScreen from "./TapFullScreen";

export default TapFullScreen;